<template>
    <span>
        <template v-if="isSuperTag">
            <i class="far fa-sparkles" />&nbsp;
        </template>
        {{ sanitizedName }}
    </span>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
    props: {
        value: {
            type: String,
            required: true
        }
    },
    computed: {
        sanitizedName() {
            return this.value.replace(/^§/, '')
        },
        isSuperTag() {
            return this.value.startsWith('§')
        }
    }
})
</script>
